var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M30.936 12c1.14 0 2.064.922 2.064 2.063V19.5l.042-.07c1.104 0 2.958 1.383 2.958 2.994v10.078A3.508 3.508 0 0132.504 36H15.459A3.468 3.468 0 0112 32.542L12 22.498c0-1.104 1.88-2.963 2.985-2.963L15 19.5v-5.438c0-1.14.924-2.062 2.064-2.062zM16.41 31.501c-.563-.003-1.47-.01-1.47.765 0 .666 1.013.757 1.562.757l14.953-.08c.55 0 1.53-.057 1.53-.782 0-.586-.942-.66-1.493-.66zM16.501 27a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm14-13.5h-13a1 1 0 00-1 1v7a1 1 0 001 1h13a1 1 0 001-1v-7a1 1 0 00-1-1z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
